/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BancaDTO } from './BancaDTO';
import {
    BancaDTOFromJSON,
    BancaDTOFromJSONTyped,
    BancaDTOToJSON,
} from './BancaDTO';

/**
 * 
 * @export
 * @interface AnagrafeDTO
 */
export interface AnagrafeDTO {
    /**
     * 
     * @type {number}
     * @memberof AnagrafeDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    cognome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    numeroCivico?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    localita?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    provincia?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    idNazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    partitaIva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    codiceFiscale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    sdi?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnagrafeDTO
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AnagrafeDTO
     */
    attivo?: boolean;
    /**
     * 
     * @type {BancaDTO}
     * @memberof AnagrafeDTO
     */
    banca?: BancaDTO;
}

/**
 * Check if a given object implements the AnagrafeDTO interface.
 */
export function instanceOfAnagrafeDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnagrafeDTOFromJSON(json: any): AnagrafeDTO {
    return AnagrafeDTOFromJSONTyped(json, false);
}

export function AnagrafeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnagrafeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'ragioneSociale': !exists(json, 'ragioneSociale') ? undefined : json['ragioneSociale'],
        'cognome': !exists(json, 'cognome') ? undefined : json['cognome'],
        'nome': !exists(json, 'nome') ? undefined : json['nome'],
        'indirizzo': !exists(json, 'indirizzo') ? undefined : json['indirizzo'],
        'numeroCivico': !exists(json, 'numeroCivico') ? undefined : json['numeroCivico'],
        'cap': !exists(json, 'cap') ? undefined : json['cap'],
        'localita': !exists(json, 'localita') ? undefined : json['localita'],
        'provincia': !exists(json, 'provincia') ? undefined : json['provincia'],
        'idNazione': !exists(json, 'idNazione') ? undefined : json['idNazione'],
        'partitaIva': !exists(json, 'partitaIva') ? undefined : json['partitaIva'],
        'codiceFiscale': !exists(json, 'codiceFiscale') ? undefined : json['codiceFiscale'],
        'sdi': !exists(json, 'sdi') ? undefined : json['sdi'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'attivo': !exists(json, 'attivo') ? undefined : json['attivo'],
        'banca': !exists(json, 'banca') ? undefined : BancaDTOFromJSON(json['banca']),
    };
}

export function AnagrafeDTOToJSON(value?: AnagrafeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'ragioneSociale': value.ragioneSociale,
        'cognome': value.cognome,
        'nome': value.nome,
        'indirizzo': value.indirizzo,
        'numeroCivico': value.numeroCivico,
        'cap': value.cap,
        'localita': value.localita,
        'provincia': value.provincia,
        'idNazione': value.idNazione,
        'partitaIva': value.partitaIva,
        'codiceFiscale': value.codiceFiscale,
        'sdi': value.sdi,
        'email': value.email,
        'attivo': value.attivo,
        'banca': BancaDTOToJSON(value.banca),
    };
}

